import { FlexContainer, CustomLabel } from "@mindmemobile/mm-shared-global";
import React, { FC } from "react";
import TickIcon from "../../../../../../../images/common/tick-green.svg";
import CrossIcon from "../../../../../../../images/products/cross-red.svg";

type IProps = {
  tax: boolean;
  discount: boolean;
  reviews: boolean;
  returnDays?: number;
};

const ItemAlowSection: FC<IProps> = ({
  tax,
  discount,
  reviews,
  returnDays,
}) => {
  return (
    <>
      <CustomLabel fontSize="20px" fontWeight="600" margin="20px 0px 30px">
        Allow
      </CustomLabel>

      <FlexContainer spacing={25} fxWrap="wrap" padding="0px 0px 10px">
        <div>
          <img
            src={tax ? TickIcon : CrossIcon}
            className="yes-no-icon"
            alt="tax"
          />
          Tax
        </div>
        <div>
          <img
            src={discount ? TickIcon : CrossIcon}
            className="yes-no-icon"
            alt="discount"
          />{" "}
          Discount
        </div>
        <div>
          <img
            src={reviews ? TickIcon : CrossIcon}
            className="yes-no-icon"
            alt="reviews"
          />{" "}
          Reviews
        </div>
        <div>
          <img
            src={returnDays && returnDays > 0 ? TickIcon : CrossIcon}
            className="yes-no-icon"
            alt="return"
          />{" "}
          {returnDays && returnDays > 0
            ? `${returnDays} Days Returns`
            : "Returns"}
        </div>
      </FlexContainer>
    </>
  );
};
export default ItemAlowSection;
